import React, { useRef, useState } from 'react';
import { Col, Container, Form, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import Step1 from '../../../Assets/images/step-1.png';
import Step2 from '../../../Assets/images/step-2.png';
import Step3 from '../../../Assets/images/step-3.png';
import Service1 from '../../../Assets/images/service-1.png';
import Service2 from '../../../Assets/images/service-2.png';
import Service3 from '../../../Assets/images/service-3.png';
import Service4 from '../../../Assets/images/service-4.png';
import Service5 from '../../../Assets/images/service-5.png';
import Service6 from '../../../Assets/images/service-6.png';
import { Button, TextField } from '@mui/material';
import swal from 'sweetalert';
import axios from 'axios';
import { base_url } from '../../../Helpers/request';

const WatchServiceRepair = () => {
  const [expand, isExpand] = useState();
  const [hidden, isHidden] = useState(false);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [mobile, setMobile] = useState('');
  const [message, setMessage] = useState('');
  const [selectedFile , setSelectedFile] = useState(null)

  const handleExpand = (num) => {
    isExpand(num);
    isHidden((prev) => !prev);
  };

  const formDiv = useRef(null);


  const scrollToDiv = () => {
    if (formDiv.current) {
      const rect = formDiv.current.getBoundingClientRect();
      const offset = window.scrollY + rect.top - 230;
      window.scrollTo({ top: offset, behavior: 'smooth' });
    }
  };


  const handleSubmit = (e) => {
    e.preventDefault()
    let formData = new FormData();
    formData.append("name", name);
    formData.append("email", email);
    formData.append("mobile", mobile);
    formData.append("message", message);
    formData.append("file", selectedFile);

    const config = {
      headers: { "content-type": "multipart/form-data" },
    };
    axios.post(base_url + "/common/jewelry_repair", formData, config)
    .then((response) => {
       if (response.data.status == 1) {
          swal(response.data.message, "", "success");
        } else {
          swal(response.data.message, "", "error");
        }
        setName("")
        setEmail("")
        setMobile("")
        setMessage("")
        setSelectedFile(null)
    })
    .catch((error) => {
      console.log(error);
    });
  }

  console.log(selectedFile , "selec")

  return (
    <div className="watch-repair-page">
      <section className="section-1">
        <Row>
          <Col lg={6}>
            <img src="https://images.unsplash.com/photo-1567937812292-3c63b472c66b?q=80&w=2071&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" alt="service" className="w-100" />
          </Col>

          <Col lg={6} className="align-self-center bg-light">
            <h2>Expert Watch Repairs</h2>
            <p>
              As the premier destination for watch repair and servicing in New York, Alicia's Jewelers is committed to ensuring that your timepiece brings joy for a lifetime, and continues to be cherished for generations to come. The proper care of a luxury watch demands meticulous attention to detail and the expertise of highly skilled watchmakers. Executing a comprehensive watch service is a
              sophisticated procedure that necessitates the proficiency of a certified and well-trained professional. Entrust your watch to Alicia's Jewelers, where our team of seven in-house master horologists ensures that your prized possession is handled with the utmost care and expertise.
            </p>
            <p>
              Kindly be aware that our quality control procedures are stringent, involving a thorough examination of movement functions and key data over an extended period, coupled with a meticulous visual inspection. This comprehensive evaluation takes place upon the conclusion of each service. Rest assured that your timepiece will only be returned to you once it successfully meets and exceeds
              our rigorous quality assurance standards.
            </p>
            <button aria-label="Start your request" onClick={scrollToDiv} className="btn" >
              Start your request
            </button>
          </Col>
        </Row>
      </section>

      <section className="repair-process pb-5 mt-5">
        <Container>
          <h2 className="text-center mb-5">The Watch Service & Repair Process</h2>
          <Row>
            <Col lg={4} className="block">
              <img src={Step1} alt="service" />
              <h3>Submit Your Watch</h3>
              <p>No appointment required! Visit our customer service center, share your concerns, and leave your watch with us. Our skilled watchmakers will inspect, make warranty notes, and conduct diagnostics.</p>
            </Col>
            <Col lg={4} className="block">
              <img src={Step2} alt="service" />
              <h3>Receive Your Estimate</h3>
              <p>Keeping your best interests in mind, we'll use the watchmaker's diagnostic findings to provide a detailed scope of work and estimate. Expect estimates within 1-3 business days for basic services, and 5-7 business days for more comprehensive evaluations after dropping off your watch.</p>
            </Col>
            <Col lg={4} className="block">
              <img src={Step3} alt="service" />
              <h3>Stay Informed!</h3>
              <p className="mb-1">We'll notify you promptly when your watch is ready. Service times:</p>
              <ul>
                <li>Same-day for battery service on request</li>
                <li>3-5 business days for refinishing</li>
                <li>2-3 weeks for maintenance</li>
                <li>4-6 weeks for complete service (current models)</li>
                <li>8-10 weeks for vintage pieces</li>
              </ul>
              <p>Note: Times may vary based on the case.</p>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="images-sec">
        <Row>
          <Col lg={4}>
            <img src="https://images.unsplash.com/photo-1523170335258-f5ed11844a49?q=80&w=2080&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" alt="service" />
          </Col>
          <Col lg={4}>
            <img src="https://images.unsplash.com/photo-1492065438790-d3c90cbc6e57?q=80&w=2080&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" alt="service" />
          </Col>
          <Col lg={4}>
            <img src="https://images.unsplash.com/photo-1490367532201-b9bc1dc483f6?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" alt="service" />
          </Col>
        </Row>
      </section>

      <section className="types-of-watch-service">
        <Container>
          <h2 className="text-center mb-5">Types of Watch Services</h2>
          <Row>
            <Col lg={4} className="text-center mb-5">
              <img src={Service1} alt="service" />
              <h4>Battery Services</h4>
              <p className={expand === 1 && hidden && 'isExpand'}>
                Looking for watch battery replacement services in New York? Beyond just changing your battery, our battery service encompasses thorough testing of movements for power consumption, starting and stopping voltage, voltage to initiate EOL (if applicable), and includes the cleaning of the case and bracelet. Additionally, we exchange the case back gasket for optimal performance.
              </p>
              <span onClick={() => handleExpand(1)}>{expand === 1 && hidden ? 'See Less' : 'See More'}</span>
            </Col>
            <Col lg={4} className="text-center mb-5">
              <img src={Service2} alt="service" />
              <h4>Maintenance Services</h4>
              <p className={expand === 2 && hidden && 'isExpand'}>
                When you suddenly need to find watch repair near me in New York, Alicia Jewelers is the best local watch repair shop. A maintenance service concentrates on the watch case. The water resistance is restored by removing the movement and disassembling the case for a full cleaning (and bracelet if applicable) and reassembling. If this is not possible, the complete crown will be
                replaced.
              </p>
              <span onClick={() => handleExpand(2)}>{expand === 2 && hidden ? 'See Less' : 'See More'}</span>
            </Col>
            <Col lg={4} className="text-center mb-5">
              <img src={Service3} alt="service" />
              <h4>Refinishing Services</h4>
              <p className={expand === 3 && hidden && 'isExpand'}>
                The refinishing service involves a comprehensive restoration of the case and bracelet to meet or exceed manufacturing standards. Scratches and dents will be skillfully removed, and surfaces will be polished to restore their original shine and satin finish. Additionally, a maintenance service will be conducted to restore water resistance.
              </p>
              <span onClick={() => handleExpand(3)}>{expand === 3 && hidden ? 'See Less' : 'See More'}</span>
            </Col>
            <Col lg={4} className="text-center mb-5">
              <img src={Service4} alt="service" />
              <h4>Complete Service (Quartz Movement):</h4>
              <p className={expand === 4 && hidden && 'isExpand'}>
                A comprehensive service for a quartz movement involves the thorough disassembly of the movement. We meticulously inspect each component for signs of wear and tear, replacing any faulty parts. The electronic module undergoes scrutiny for power consumption, frequency, and other pertinent operations dictated by the integrated circuit. Following this, we meticulously assemble the
                movement, ensuring proper lubrication, and conduct thorough functionality checks, including the electronic module in its assembled state. The case is then integrated with the movement, and we meticulously restore water resistance.
              </p>
              <span onClick={() => handleExpand(4)}>{expand === 4 && hidden ? 'See Less' : 'See More'}</span>
            </Col>
            <Col lg={4} className="text-center mb-5">
              <img src={Service5} alt="service" />
              <h4>Complete Service (Mechanical Movement):</h4>
              <p className={expand === 5 && hidden && 'isExpand'}>
                A comprehensive service for a mechanical movement involves the complete disassembly of the mechanism. Every part undergoes a meticulous examination for wear and tear, with any defective components promptly replaced. Corrosion is removed, and a thorough cleaning of all parts ensues. The movement is then expertly reassembled, with meticulous tolerance checks conducted according to
                manufacturing specifications. Lubrication is applied to the movement, and comprehensive functional checks are performed, including adjustments to timing and escapement for accuracy. The process concludes with the meticulous restoration of water resistance and the integration of the case with the movement.
              </p>
              <span onClick={() => handleExpand(5)}>{expand === 5 && hidden ? 'See Less' : 'See More'}</span>
            </Col>
            <Col lg={4} className="text-center mb-5">
              <img src={Service6} alt="service" />
              <h4>Restoration Service (Mechanical Vintage Movement):</h4>
              <p className={expand === 6 && hidden && 'isExpand'}>
                A comprehensive restoration service encompasses all aspects of the complete service for mechanical movements. However, the need for a restoration service arises when certain parts are no longer available. In such cases, the restoration process involves the meticulous creation of necessary components. This includes crafting parts by hand or using tools such as a lathe, grinder, or
                mill, based on technical drawings of the damaged part, which extends to wheels, gears, levers, and other intricate components, instead of the conventional method of ordering and replacing the faulty part.
              </p>
              <span onClick={() => handleExpand(6)}>{expand === 6 && hidden ? 'See Less' : 'See More'}</span>
            </Col>
          </Row>
        </Container>
      </section>

      <div className="watch-repair-form py-5 mt-5 bg-light" ref={formDiv}>
        <Container>
          <h3 className="text-center mb-1">Fill the Form</h3>
          <p className="text-center mb-5">Restore the sparkle to your favorite jewelry pieces.</p>

          <Form onSubmit={handleSubmit}>
            <Row className="m-auto w-100">
              <Col md={6} className="offset-md-3">
                <TextField  labelId="rcs_choose_type"  className="w-100 mb-3" label="Name" type="text" value={name} onChange={(e) => setName(e.target.value)} required variant="outlined"></TextField>

                <TextField  labelId="rcs_choose_type" className="w-100 mb-3" label="Email Address" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required variant="outlined"></TextField>

                <TextField  labelId="rcs_choose_type"  className="w-100 mb-3" label="Mobile Number" type="number" value={mobile} onChange={(e) => setMobile(e.target.value)} required variant="outlined"></TextField>
                <TextField
                   labelId="rcs_choose_type" 
                  label="Upload"
                  type="file"
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => setSelectedFile(e.target.files[0])}
                  helperText="Choose your file here to upload. Allowed type(pdf,jpg,png,jpeg,doc,docx)"
                  className="w-100 mb-3"
                ></TextField>
                <TextField id="filled-multiline-static" label="Message" type="text" multiline className="w-100 mb-4" rows={4} value={message} onChange={(e) => setMessage(e.target.value)} variant="outlined"></TextField>
                <Button aria-label="Submit" variant="contained" type="submit" className="rcs_acc_button rcs_review_btn">
                  Submit
                </Button>
              </Col>
            </Row>
          </Form>
        </Container>
      </div>

      <div className="my-5"></div>
    </div>
  );
};

export default WatchServiceRepair;
